import { vySerialize } from '@vy/utils';
import { useTablePagination } from './use-table-pagination';
import { useTableSorting } from './use-table-sorting';

type UseTableDataFromParamsReturn = {
  page: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  sort: string | undefined;
};

export function useTableDataFromParams(): UseTableDataFromParamsReturn {
  const { page, pageSize, onPageChange, onPageSizeChange } = useTablePagination();
  const { currentSortModel } = useTableSorting();

  return {
    page: page ?? 0,
    pageSize: pageSize ?? 50,
    onPageChange,
    onPageSizeChange,
    sort: vySerialize(currentSortModel),
  };
}
